import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { ENPOINT } from '../endpoint';

import { Options } from 'selenium-webdriver/safari';
import { GLOBAL } from '../global';

@Injectable()
export class InvoicesDCService {

  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;


  cargarFactura(cfdi, proveedor, switchTipo, form, fd): Observable<any> {
    const params = fd;
    // tslint:disable-next-line:max-line-length
    const httpHeaders = new HttpHeaders().set('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('tipoProceso', switchTipo)
      .set('numDocSap', form.documentoSap)
      .set('sinCfdi', cfdi)
      .set('proveedor', proveedor)
      .set('moneda', form.monedaForm)
      .set('total', form.importe)
      .set('contacto', form.correo)
      .set('sociedad', form.sociedadForm)
      .set('anioDocumento', form.anioDocumento)
    };
    return this.http.post(this.basePath + 'documento-contable/carga', params, options);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/invoices-dc/invoices-dc.service.ts